module.exports = __webpack_public_path__ + "static/media/4.8ba57c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/4.png
// module id = 625
// module chunks = 0